/**
 * auth.js - Centralised auth helpers for SkillArea.
 * Stores role-specific tokens (token_hirer, token_technician, token_admin)
 * so simultaneous multi-role sessions never corrupt each other.
 */

export function getToken() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (user.role) {
    const roleToken = localStorage.getItem(`token_${user.role}`);
    if (roleToken) return roleToken;
  }
  return localStorage.getItem('token');
}

export function getUser() {
  return JSON.parse(localStorage.getItem('user') || '{}');
}

export function setAuth(role, token, userData) {
  localStorage.removeItem('token_hirer');
  localStorage.removeItem('token_technician');
  localStorage.removeItem('token_admin');
  localStorage.setItem(`token_${role}`, token);
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(userData));
}

export function clearAuth() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (user.role) localStorage.removeItem(`token_${user.role}`);
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}
